import { useQuery } from '@tanstack/react-query'
import { queryKeys } from '@/lib/queryKeys'
import {
  fetchStoreAttributes,
  fetchStoreAttributeValues,
  fetchPogGroups,
} from '@/api/stores'

export function useStoreAttributes() {
  return useQuery({
    queryKey: queryKeys.stores.attributes(),
    queryFn: fetchStoreAttributes,
    staleTime: 10 * 60 * 1000, // 10 minutes
  })
}

export function useStoreAttributeValues(fieldName: string | null) {
  return useQuery({
    queryKey: queryKeys.stores.attributeValues(fieldName ?? ''),
    queryFn: () => fetchStoreAttributeValues(fieldName!),
    enabled: !!fieldName,
    staleTime: 5 * 60 * 1000, // 5 minutes
  })
}

export function usePogGroups() {
  return useQuery({
    queryKey: queryKeys.stores.pogGroups(),
    queryFn: fetchPogGroups,
    staleTime: 10 * 60 * 1000,
  })
}
